// Spark A V1 — line A with 4-point spark crossbar
// Used as the official App Academy mark
export function LogoMark({ size = 32 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <defs>
        <linearGradient id="logoMarkGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#7ee0a7"/>
          <stop offset="1" stopColor="#2a9d68"/>
        </linearGradient>
      </defs>
      <rect x="0" y="0" width="64" height="64" rx="14" fill="url(#logoMarkGrad)"/>
      {/* Left leg of A */}
      <path d="M30 14 L13 50" stroke="#06070b" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
      {/* Right leg of A */}
      <path d="M34 14 L51 50" stroke="#06070b" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
      {/* 4-point spark replacing crossbar */}
      <path
        d="M32 30 L34 36 L40 38 L34 40 L32 46 L30 40 L24 38 L30 36 Z"
        fill="#06070b"
      />
    </svg>
  );
}
